import { required, maxLength } from 'vuelidate/lib/validators';

export const pageTitleMaxLength = 150;

export default {
  required,
  maxLength: maxLength(pageTitleMaxLength),
};
